import { render, staticRenderFns } from "./AppDate.vue?vue&type=template&id=226b4b78&scoped=true&"
import script from "./AppDate.vue?vue&type=script&lang=js&"
export * from "./AppDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b4b78",
  null
  
)

export default component.exports